<template>
  <div>
    <div>
      <ElXlsx @upData="upData" />
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="timer" label="时间类型">
      </el-table-column>
      <el-table-column prop="tz" label="统招类">
      </el-table-column>
      <el-table-column prop="yz" label="运作类">
      </el-table-column>
      <el-table-column prop="qdtz" label="渠道拓展">
      </el-table-column>
      <el-table-column prop="hyw" label="行业外">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import ElXlsx from '../../components/ElXlsx.vue'
  export default {
    components: {
      ElXlsx
    },
    inject: ['reload'],
    data() {
      return {
        tableData: [],
        items: ['timer', 'tz', 'yz', 'qdtz', 'hyw']
      }
    },
    mounted() {
      this.$axios.post('/annual_route/findList').then(res => {
        this.tableData = res.data.data
      })
    },
    methods: {
      upData(e) {
        let dataArr = this.$replaceString(e, this.items)
        // console.log(dataArr)
        this.$axios.post('/annual_route/save', dataArr).then(res => {
          this.$message({
            message: '导入成功。',
            type: 'success'
          })
          this.reload()
        })
      },
    }
  }
</script>

<style scoped>
  .el-table {
    margin-top: 20px;
  }
</style>